import { Button, Divider, Flex, Modal, Typography } from 'antd'
import { useModalRequestsToSubmit } from 'src/pages/budget/budgetRequests/hooks'
import {
  closeModalRequestsToSubmit,
  submitRequestFx,
  reloadBudgetRequests,
} from 'src/pages/budget/budgetRequests/model'
import { UiText } from 'src/pages/budget/components'
import { showNotification } from 'src/features/notifications'

export const ModalRequestsToSubmit = () => {
  const modalRequestsToSubmit = useModalRequestsToSubmit()

  if (!modalRequestsToSubmit) return null

  const { items } = modalRequestsToSubmit
  const open = Boolean(modalRequestsToSubmit)

  const handleCancel = () => closeModalRequestsToSubmit()
  const handleOk = async () => {
    const results = await Promise.allSettled(
      items.map(({ id }) =>
        submitRequestFx({
          url: `/budget/budget_request/${id}/submit`,
          body: { url: `/budget/budget_request/${id}/submit`, id },
        }),
      ),
    )
    const failedIds = results.flatMap((result, index) => result.status === 'rejected' ? [items[index].id] : [])
    reloadBudgetRequests()
    showNotification({
      type: failedIds.length ? 'warning' : 'success',
      message: failedIds.length ? `Не отправлены заявки №${failedIds.join(', ')}` : `Отправлено на согласование: ${items.length}`,
      description: failedIds.length ? 'Остальные выбранные заявки отправлены на согласование.' : '',
    })
    closeModalRequestsToSubmit()
  }
  const ids = items.map(({ id }) => id)

  return (
    <Modal
      title={
        <div style={{ fontSize: 20 }}>
          Отправить {ids.length > 1 ? 'заявки' : 'заявку'} на согласование
        </div>
      }
      centered
      wrapClassName="ant_modal"
      width={500}
      maskClosable={false}
      open={open}
      destroyOnHidden
      onCancel={handleCancel}
      footer={
        <Flex gap={8}>
          <Button size="large" style={{ flex: 1 }} onClick={handleCancel}>
            Отменить
          </Button>
          <Button
            size="large"
            style={{ flex: 1 }}
            color="cyan"
            variant="solid"
            onClick={handleOk}
          >
            Отправить
          </Button>
        </Flex>
      }
    >
      <Divider />
      <UiText size={18}>
        Вы уверены, что хотите отправить{' '}
        {ids.length > 1 ? 'заявки №' : 'заявку №'}
        <UiText size={18} strong>
          {' '}
          {ids.join(', ')}
        </UiText>{' '}
        на согласование?
      </UiText>
      <Divider />
    </Modal>
  )
}
